import React, { useEffect, useState } from "react";
import { Loader } from "rsuite";
import { axInstBasic } from "../../../components/Service/Service";
import VerticalBarChart from "../../../components/Charts/VerticalBarChart";

const fetchStateWiseChassis = async (isArn) => {
  try {
    // axInstBasic includes:
    // - baseURL
    // - Basic Auth
    // - withCredentials (cookies sent automatically)
    const res = await axInstBasic.post("StateWiseChassis", { isArn });

    return res.data.result || [];
  } catch (error) {
    console.error("API Error:", error.response?.data || error.message);
    throw new Error("Failed to fetch State Wise Chassis data");
  }
};

export default function StatewiseChasisRegisted({ isArn }) {
  const [chartData, setChartData] = useState({ keyData: [], valData: [] });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!isArn) return; // wait until ARN available

    const fetchData = async () => {
      setLoading(true);
      setError(null);

      try {
        const apiData = await fetchStateWiseChassis(isArn);

        // Extract state names and chassis counts
        const keyData = apiData
          .map((item) => item?.key)
          .filter(Boolean)
          .reverse();

        const valData = apiData
          .map((item) => item?.chassis_count?.value ?? 0)
          .reverse();

        setChartData({ keyData, valData });
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [isArn]);

  // 🌀 Loading
  if (loading) {
    return (
      <div className="grid place-items-center w-full h-full py-8">
        <Loader />
      </div>
    );
  }

  // ❌ Error
  if (error) {
    return <p className="text-red-500 text-center py-4">Error: {error}</p>;
  }

  // ⚠️ Empty state
  if (!chartData.keyData.length) {
    return (
      <p className="text-gray-500 text-center py-4">
        No data available to display.
      </p>
    );
  }

  // 📊 Render chart
  return (
    <div className="p-2 relative">
      <VerticalBarChart
        data={chartData}
        heading="State Wise Chassis Registered"
        top="20%"
        height="250px"
      />
    </div>
  );
}
